import { Box, useColorMode } from 'native-base';
import { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const ScrollToTopButton = () => {
  const { colorMode } = useColorMode();
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Mostrar el botón después de hacer scroll 300px hacia abajo
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      onClick={scrollToTop}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      style={{
        position: 'fixed',
        bottom: '30px',
        right: '30px',
        zIndex: 1000,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
      }}>
      <Box
        width="50px"
        height="50px"
        borderRadius="50%"
        bg={colorMode === 'light' ? '#293d8b' : '#ffb31c'}
        display="flex"
        alignItems="center"
        justifyContent="center"
        shadow="lg"
        //@ts-ignore
        style={{
          transform: isPressed ? 'scale(0.95)' : isHovered ? 'scale(1.1)' : 'scale(1)',
          transition: 'all 0.2s ease',
          opacity: isPressed ? 0.8 : 1,
        }}>
        <FaArrowUp
          size={20}
          color={colorMode === 'light' ? '#ffffff' : '#293d8b'}
        />
      </Box>
    </div>
  );
};

export default ScrollToTopButton;

